module.exports = "/_next/static/images/cr-74dd61b6fdb8b783d209a264af09c363.svg";